export function downloadFile(fileString: string, fileName: string, fileType: string): void {
  const link = document.createElement("a")
  link.href = window.URL.createObjectURL(new Blob([fileString], { type: fileType }))
  link.download = fileName
  link.click()
}
